module.exports = __webpack_public_path__ + "img/spec_detail_m.5a8c44c1.jpg";